



























import Vue from "vue";
import Loader from "@/components/Loader.vue";
import ContentEmpty from "@/components/Empty.vue";
import SiteHeader from "@/components/Header.vue";
import SiteFooter from "@/components/Footer.vue";
import DownloadDialog from "@/components/DownloadDialog.vue";
import Waterfall from "@/components/Waterfall.vue";
import WaterfallHeader from "@/components/WaterfallHeader.vue";
import eventEmitter from "@/utils/eventEmitter";
import feedMixin from "@/mixins/feed";
import { IFeedItem } from "@/types/post";

export default Vue.extend({
  mixins: [feedMixin],
  components: {
    Loader,
    ContentEmpty,
    SiteHeader,
    DownloadDialog,
    SiteFooter,
    Waterfall,
    WaterfallHeader,
  },
  async asyncData({ store, params, req }) {
    try {
      const { id } = params;
      const [infoRes, feedRes] = await Promise.all([
        store.dispatch("post/fetchZoneInfo", { id }),
        store.dispatch("post/fetchZoneLabelResource", { class_id: id }),
      ]);

      return {
        infos: infoRes,
        feeds: feedRes.data,
      };
    } catch (e) {
      console.log("zone ssr request error >>>", e);
      return {
        error: "error",
      };
    }
  },
  data() {
    return {
      error: "",
      downloadVisible: false,
      feedToDownload: {},
      isFromMobile: false,
      zoneId: this.$route.params.id,
    };
  },
  head() {
    return {
      title: this.zoneInfo.name
        ? `${this.zoneInfo.name} - 迅雷小站 - 精品资源下载站`
        : "迅雷小站 - 精品资源下载站",
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "keywords",
          name: "keywords",
          content: this.keywords,
        },
      ],
    };
  },
  computed: {
    curUser() {
      return this.$store.state.user.curUser;
    },
    hasLogin() {
      return this.curUser.userId !== "0";
    },
    zoneRes() {
      return this.$store.state.post.zoneLabelResource;
    },
    list() {
      return this.zoneRes.list;
    },
    hasMore() {
      return this.zoneRes.hasMore;
    },
    zoneInfo() {
      return this.$store.state.post.zoneInfo;
    },
    description() {
      let desc = this.zoneInfo.name;
      if (this.zoneInfo && this.zoneInfo.remark) {
        desc += `,${this.zoneInfo.remark}`;
      }
      return desc;
    },
    keywords() {
      const words: string[] = [];
      if (this.zoneInfo && this.zoneInfo.name) {
        words.push(this.zoneInfo.name);
      }

      if (
        this.zoneInfo &&
        this.zoneInfo.labels &&
        this.zoneInfo.labels.length
      ) {
        for (let label of this.zoneInfo.labels) {
          words.push(label);
        }
      }

      if (this.list.length) {
        for (let item of this.list.slice(0, 5)) {
          words.push(item.res_name);
        }
      }

      return Array.from(new Set(words)).join(",");
    },
  },
  async mounted() {
    if (this.$refs.listElem) {
      // in case of ssr error
      const ssrError = this.$refs.listElem.getAttribute("data-ssr");
      if (ssrError === "error") {
        this.fetchZoneResList();
        await this.$store.dispatch("post/fetchZoneInfo", {
          id: this.zoneId,
        });
      }
    }

    eventEmitter.on("feed-download-fail", (item: IFeedItem) => {
      this.feedToDownload = item;
      this.downloadVisible = true;
    });

    eventEmitter.on("open-mac-download", ({ files, links }: any) => {
      this.feedToDownload = { files, directLinks: links };
      this.downloadVisible = true;
    });

    setTimeout(() => {
      this.stat("xiaozhan_zone_page_show", {
        zone_name: encodeURIComponent(this.zoneInfo.name),
      });
    }, 800);
  },
  beforeDestroy() {
    eventEmitter.off("feed-download-fail", 0);
    eventEmitter.off("open-mac-download", 0);
  },
  methods: {
    stat(action: string, data: any) {
      this.$stat("xiaozhan", action, data);
    },
    async fetchZoneResList(refresh = true) {
      const params = {
        refresh,
        class_id: this.zoneId,
      };
      await this.$store.dispatch("post/fetchZoneLabelResource", params);
      this.loading = false;
    },
    loadMore(visible: boolean) {
      if (visible) {
        setTimeout(() => {
          this.fetchZoneResList(false);
        }, 0);
      }
    },
  },
});
